import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import MaintenancePage from './pages/MaintenancePage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import ClientMaintenance from './components/Maintenance/Clients/ClientMaintenance';
import ProviderMaintenance from './components/Maintenance/Providers/ProviderMaintenance';
import FamiliaProductosMaintenance from './components/Maintenance/Families/FamiliaProductosMaintenance';
import ProductMaintenance from './components/Maintenance/Products/ProductMaintenance';
import AlmacenMaintenance from './components/Maintenance/Warehouses/AlmacenMaintenance';
import MovimientosMaintenance from './components/Maintenance/Movements/MovimientosMaintenance';
import TransferenciasMaintenance from './components/Maintenance/Transfers/TransferenciasMaintenance';
import ConversionesMaintenance from './components/Maintenance/Conversions/ConversionesMaintenance';
import StockInventario from './components/Maintenance/Stocks/StockInventario';
import ComprasMaintenance from './components/Maintenance/Purchases/ComprasMaintenance';
import CuentasPagarMaintenance from './components/Maintenance/CuentasPagar/CuentasPagarMaintenance';
import CuentasCobrarMaintenance from './components/Maintenance/CuentasCobrar/CuentasCobrarMaintenance';
import CobranzasMaintenance from './components/Maintenance/Cobranzas/CobranzasMaintenance';
import AperturaCajas    from './components/Maintenance/Caja/AperturaCajas';
import HistorialCuadres from './components/Maintenance/Caja/HistorialCuadres';
import VentasListado    from './components/Maintenance/Ventas/VentasListado';
import NuevaVenta       from './components/Maintenance/Ventas/NuevaVenta';
import ReportesPage from './pages/ReportesPage';
import EmpresasPage from './pages/EmpresasPage';
import UsuariosPage from './pages/UsuariosPage';
import RolesPage from './pages/RolesPage';
import './styles/App.css';

// Rutas internas — pueden usar useAuth() porque están dentro de AuthProvider
function AppRoutes() {
  const { user, isSuperAdmin } = useAuth();
  const businessId = user?.business_id;

  return (
    <Layout>
      <Routes>
        <Route path="/"                    element={<Dashboard businessId={businessId} />} />
        <Route path="/config/*"            element={<ConfiguracionPage businessId={businessId} />} />
        <Route path="/clientes/*"          element={<ClientMaintenance businessId={businessId} />} />
        <Route path="/proveedores/*"       element={<ProviderMaintenance businessId={businessId} />} />
        <Route path="/familia-productos/*" element={<FamiliaProductosMaintenance businessId={businessId} />} />
        <Route path="/productos/*"         element={<ProductMaintenance businessId={businessId} />} />
        <Route path="/almacenes/*"         element={<AlmacenMaintenance businessId={businessId} />} />
        <Route path="/movimientos/*"                element={<MovimientosMaintenance businessId={businessId} />} />
        <Route path="/inventarios/transferencias/*" element={<TransferenciasMaintenance businessId={businessId} />} />
        <Route path="/inventarios/conversiones/*"   element={<ConversionesMaintenance   businessId={businessId} />} />
        <Route path="/inventarios/stocks/*"         element={<StockInventario           businessId={businessId} />} />
        <Route path="/compras/*"                   element={<ComprasMaintenance        businessId={businessId} />} />
        <Route path="/cuentas-pagar/*"             element={<CuentasPagarMaintenance   businessId={businessId} />} />
        <Route path="/cuentas-cobrar"               element={<CuentasCobrarMaintenance  businessId={businessId} />} />
        <Route path="/cobranzas"                   element={<CobranzasMaintenance      businessId={businessId} />} />
        <Route path="/caja/cajas"                  element={<AperturaCajas />} />
        <Route path="/caja/historial"               element={<HistorialCuadres businessId={businessId} />} />
        <Route path="/ventas"                      element={<VentasListado businessId={businessId} />} />
        <Route path="/ventas/nueva"                element={<NuevaVenta />} />
        <Route path="/reportes"                    element={<Navigate to="/reportes/ventas" />} />
        <Route path="/reportes/:tab"               element={<ReportesPage businessId={businessId} />} />
        <Route path="/empresas"                    element={<EmpresasPage />} />
        <Route path="/usuarios"                    element={<UsuariosPage />} />
        <Route path="/roles"                       element={<RolesPage />} />
        <Route path="/maintenance/*"               element={<MaintenancePage businessId={businessId} />} />
        <Route path="*"                    element={<Navigate to={isSuperAdmin ? '/empresas' : '/'} />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppRoutes />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
